import React from "react";

import { Modal } from "react-bootstrap";

import CompaniesCard from "../pop-up-card/companies-card";

/**
 * MoreInfoModal Component
 * 
 * Bootstrap modal for displaying detailed information about a selected company or record.
 * Renders CompaniesCard component within modal body showing comprehensive company details.
 * Modal state controlled by parent through showMoreInfoCard flag and hideCard callback.
 * Includes close button and full-screen responsive behavior for mobile devices.
 * 
 * @param {Object} props - Component props containing modal state and data
 * @param {boolean} props.showMoreInfoCard - Flag controlling modal visibility
 * @param {Function} props.hideCard - Callback to close modal
 * @param {Object} props.moreInfo - Company or record data to display
 * @returns {JSX.Element} Modal dialog with company information card
 */
const MoreInfoModal = ({ props }) => {
  const { showMoreInfoCard, hideCard, moreInfo } = props;

  return (
    <Modal
      show={showMoreInfoCard}
      onHide={hideCard}
      backdrop="static"
      fullscreen="sm-down"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="companies-header close" closeButton />

      <Modal.Body className="companies-body">
        {moreInfo.map((companies) => (
          <div key={companies.slug}>
            <CompaniesCard
              slug={companies.slug}
              name={companies.name}
              tradeName={companies.tradeName}
              description={companies.description}
              logo={companies.logo}
              reasonsForFailure={companies.reasonsForFailure}
              categories={companies.categories}
              location={companies.location}
              country={companies.country}
              countryCode={companies.countryCode}
              state={companies.state}
              city={companies.city}
              industry={companies.industry}
              products={companies.products}
            />
          </div>
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default MoreInfoModal;
